import { apiClient } from './apiClient';

export const sindicatoService = {
  getViews: async () => {
    const response = await apiClient.get('/sindicato-views');
    return response.data;
  },

  createView: async (data) => {
    const response = await apiClient.post('/sindicato-views', data);
    return response.data;
  },

  updateView: async (id, data) => {
    const response = await apiClient.put(`/sindicato-views/${id}`, data);
    return response.data;
  },

  deleteView: async (id) => {
    await apiClient.delete(`/sindicato-views/${id}`);
  },

  getViewDashboard: async (id) => {
    const response = await apiClient.get(`/sindicato-views/${id}/dashboard`);
    return response.data;
  },

  getViewDashboardByProcess: async (id) => {
    const response = await apiClient.get(`/sindicato-views/${id}/dashboard/by-process`);
    return response.data;
  },

  getViewTheme: async (id) => {
    const response = await apiClient.get(`/sindicato-views/${id}/theme`);
    return response.data;
  },

  getViewThemeBySlug: async (slug) => {
    const response = await apiClient.get(`/sindicato-views/by-slug/${slug}/theme`);
    return response.data;
  },
};
